import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 text-center card-soft animate-pop">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-secondary"><XCircle className="h-9 w-9 text-muted-foreground" /></div>
        <h1 className="mt-4 text-2xl font-extrabold">Checkout canceled</h1>
        <p className="mt-1 text-muted-foreground">No worries — you weren’t charged. You can upgrade whenever you’re ready.</p>
        <button onClick={() => nav('/app/profile')} className="coral-btn mt-6 w-full rounded-2xl py-3.5 font-bold text-white">Back to Purrflect</button>
      </div>
    </div>
  );
}
